import React from 'react';
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import LinearProgress from '@mui/material/LinearProgress';
import Divider from '@mui/material/Divider';

import { CircularProgress } from '@mui/material';

const ProjectRoleSummary = ({ loading, stats }) => {
  const total = stats?.totals?.totalProjects || 0;
  const byRole = stats?.projectsByRole || {};

  return (
    <div className="UserSummary">
      <div className="summaryContainer">
        <div className="summary">
          <div className="number">{loading ? <CircularProgress size={30} /> : total}</div>
          <div className="text">Projects by Plan</div>
        </div>
        <div className="icon">
          <FolderSharedIcon color="primary" fontSize="large" />
        </div>
      </div>
      <Divider />
      <div className="activeUsersBar">
        <div className="barTexts">
          <div className="barTitle">Basic:</div>{' '}
          <div>{loading ? <CircularProgress size={10} /> : byRole.basic || 0}</div>
        </div>
        <LinearProgress
          variant="determinate"
          value={loading || total === 0 ? 0 : ((byRole.basic || 0) / total) * 100}
          title={
            loading || total === 0 ? 0 : `${Math.floor(((byRole.basic || 0) / total) * 100)}%`
          }
        />
      </div>
      <div className="activeUsersBar">
        <div className="barTexts">
          <div className="barTitle">Standard:</div>{' '}
          <div>{loading ? <CircularProgress size={10} /> : byRole.standard || 0}</div>
        </div>
        <LinearProgress
          variant="determinate"
          value={loading || total === 0 ? 0 : ((byRole.standard || 0) / total) * 100}
          title={
            loading || total === 0 ? 0 : `${Math.floor(((byRole.standard || 0) / total) * 100)}%`
          }
        />
      </div>
      <div className="activeUsersBar">
        <div className="barTexts">
          <div className="barTitle">Premium:</div>{' '}
          <div>{loading ? <CircularProgress size={10} /> : byRole.premium || 0}</div>
        </div>
        <LinearProgress
          variant="determinate"
          value={loading || total === 0 ? 0 : ((byRole.premium || 0) / total) * 100}
          title={
            loading || total === 0 ? 0 : `${Math.floor(((byRole.premium || 0) / total) * 100)}%`
          }
        />
      </div>
      <div className="activeUsersBar">
        <div className="barTexts">
          <div className="barTitle">Professional:</div>{' '}
          <div>{loading ? <CircularProgress size={10} /> : byRole.professional || 0}</div>
        </div>
        <LinearProgress
          variant="determinate"
          value={loading || total === 0 ? 0 : ((byRole.professional || 0) / total) * 100}
          title={
            loading || total === 0 ? 0 : `${Math.floor(((byRole.professional || 0) / total) * 100)}%`
          }
        />
      </div>
    </div>
  );
};

export default ProjectRoleSummary;
